import React from 'react';
import PropTypes from 'prop-types';
import Navigateup from '@nerdwallet/react-icon/gizmo/Navigateup';
import Navigatedown from '@nerdwallet/react-icon/gizmo/Navigatedown';

const NavigateToggle = ({ isUp }) =>
  isUp ? (
    <Navigateup className="navigate navigate-up" />
  ) : (
    <Navigatedown className="navigate navigate-down" />
  );

NavigateToggle.propTypes = {
  isUp: PropTypes.bool,
};

export default NavigateToggle;
